import { render } from "./ServicioTecnico.vue?vue&type=template&id=6ab82d27"
import script from "./ServicioTecnico.js?vue&type=script&lang=js&external"
export * from "./ServicioTecnico.js?vue&type=script&lang=js&external"

import "./ServicioTecnico.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__